import React from 'react'

// core components
import AutoCompleteDropdown from 'components/CustomDropdown/AutoCompleteDropdown'

// Apollo thingy
import { graphql, Query } from 'react-apollo'

//wrapper specific, each dropdown needs a specific one
import { dictCompanies } from '../../queries/getDataForDropdowns'

// props here holds the classes and pass it down
const namePlaceholder = props => (
  <Query query={dictCompanies} errorPolicy="all">
    {({ loading, error, data }) => {
      // console.log(data)
      if (error) return <p>Database connection error</p>
      if (loading) {
        return <p>Loading...</p>
      } else {
        const { helperText = 'Choose a company ...', labelText = '', ...rest } = props
        return <AutoCompleteDropdown options={data.companies.map(d => ({ ...d, label: d.name, value: d.id }))} placeholder={helperText} labelText={labelText} {...rest} />
      }
    }}
  </Query>
)

export default graphql(dictCompanies)(namePlaceholder)
